import { createBasket, updateBasket } from '@store/basket/actions';
import { connect } from 'react-redux';
import { basketSelectors } from '@store/basket/selectors';
import { SubmitButton } from './SubmitButton';
import { StateProps } from './SubmitButton.types';

const mapStateToProps = (state: StateProps): StateProps => ({
  currentBasketItems: basketSelectors.getBasketDetails(state)?.items,
});

const mapDispatchToProps = {
  createBasket,
  updateBasket,
};

export const SubmitButtonConnected = connect(mapStateToProps, mapDispatchToProps)(SubmitButton);
